

























































import { ContactLensImageType } from '@/services/contact-lens-image-type/contact-lens-image-type-storage'
import { imageUrlFor, ProductCard } from '@hl-itemlist/model/product-card'
import { ProductPriceView } from '@hl-itemlist/model/product-price'
import {
  isSpColumnCount,
  SP_COLUMN_FOUR,
  SP_COLUMN_THREE,
  SP_COLUMN_TWO,
  SpColumnCount,
} from '@hl-itemlist/model/sp-column-count'
import Vue, { PropType } from 'vue'

export default Vue.extend({
  props: {
    imageType: {
      type: String as PropType<ContactLensImageType>,
      required: true,
    },
    /**
     * 価格は一覧とは別APIで取得するため、取得未完了の間はnull(価格欄は空のまま高さだけ確保)。
     * 取得完了後は「価格なし(￥-)」表示も含め必ず渡る。
     */
    price: {
      type: Object as PropType<ProductPriceView | null>,
      default: null,
    },
    product: {
      type: Object as PropType<ProductCard>,
      required: true,
    },
    /**
     * スマホ表示時の一覧の列数。カード幅が狭くなるSP向けの表示切替
     * (3列=スペック文字を小さく、4列=画像のみで商品名などは画像内の表記に委ねる)に使う。
     * PC幅では常に全要素を表示するため効果を持たない。
     */
    spColumnCount: {
      type: Number as PropType<SpColumnCount>,
      required: true,
      validator: isSpColumnCount,
    },
  },
  computed: {
    // 列数のクラスは常にいずれか1つが付く(グリッド側と同じ方式。ProductGridのitemsClassのコメント参照)
    cardClass(): { [key: string]: boolean } {
      return {
        'hl-item-card--sp-column-2': this.spColumnCount === SP_COLUMN_TWO,
        'hl-item-card--sp-column-3': this.spColumnCount === SP_COLUMN_THREE,
        'hl-item-card--sp-column-4': this.spColumnCount === SP_COLUMN_FOUR,
      }
    },
    imageUrl(): string {
      return imageUrlFor(this.product.images, this.imageType)
    },
    /**
     * 装用期間セルの色分け。語彙(BFFの値)ごとに色を割り当てる。
     */
    periodClass(): { [key: string]: boolean } {
      const value = this.product.expirationPeriod ? this.product.expirationPeriod.value : null

      return {
        'hl-item-card__spec--one-day': value === 'oneDay',
        'hl-item-card__spec--two-weeks': value === 'twoWeeks',
        'hl-item-card__spec--one-month': value === 'oneMonth',
      }
    },
  },
})
